import React from 'react';
import { IconSvgProps } from '@models/common';

const Search: React.FC<IconSvgProps> = (props) => {
  const { size = 28, strokeWidth = 2.33333, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='18 18 28 28'
      fill='none'>
      <path
        d='M40.1667 30.8333C40.1667 35.988 35.988 40.1667 30.8333 40.1667C25.6787 40.1667 21.5 35.988 21.5 30.8333C21.5 25.6787 25.6787 21.5 30.8333 21.5C35.988 21.5 40.1667 25.6787 40.1667 30.8333Z'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42.5 42.5L37.425 37.425'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Search;
